// utils/tableColumns.js
import React from 'react';
import Dot from '../../components/Dot';
import ColoredTag from '../../components/ColoredTag';


export const getColorByRank = (index) => {
    const colorShade = `rgba(0, 0, 0, ${1/index})`;
    return colorShade;
};
// Reusable Rank Column
export const RankColumn = {
  title: "Rank",
  dataIndex: "rank",
  key: "rank",
  render: (_, record, index) => (
    <Dot size={20} color={getColorByRank(index)} label={index + 1} />
  ),
    width: 40
};

// Reusable Name Column
export const NameColumn = (itemColors) => ({
  title: 'Name',
  dataIndex: 'symbol',
  key: 'symbol',
  render: (_, record) => (
    <ColoredTag
      color={itemColors?.[record.id]}
      name={record?.label}
      width={'100%'}
      shadow={false}
    />
  ),
  width: '20vw',
  minWidth: 150,
});
